import newRelic from '@mortgage-pos/ui/services/newRelic'
import React from 'react'

interface ErrorState {
  hasError: boolean
}

export class AutoCompleteErrorBoundary extends React.Component<{}, ErrorState> {
  constructor(props) {
    super(props)
    this.state = { hasError: false }
  }

  static getDerivedStateFromError() {
    // Update state so the next render will show the fallback UI.
    return { hasError: true }
  }

  componentDidCatch() {
    newRelic.increment('address.autocomplete.error')
    // You can also log the error to an error reporting service
  }

  render() {
    return this.props.children
  }
}
